import React, { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import { FiltersService } from '../../services/FiltersService';
import { DROPDOWN_CODES } from '../../constants/dropdown.constants';
import SimpleDropdown from './SimpleDropdown';

interface EmploymentTypeDropdownProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  onDropdownLoad?: () => void; // Callback when dropdown options are loaded
}

const EmploymentTypeDropdown: React.FC<EmploymentTypeDropdownProps> = ({
  value,
  onChange,
  placeholder = "Select Employment Type",
  disabled = false,
  onDropdownLoad
}) => {
  const [employmentOptions, setEmploymentOptions] = useState<{key: string, label: string}[]>([]);
  const [loading, setLoading] = useState(false);

  const loadEmploymentOptions = useCallback(async () => {
    setLoading(true);
    try {
      const employmentTypes = await FiltersService.getDropdownItems(DROPDOWN_CODES.EmploymentType);
      setEmploymentOptions(employmentTypes.map(item => ({
        key: (item.value || '').trim(),
        label: item.label || ''
      })));
      if (onDropdownLoad) onDropdownLoad();
    } catch (error) {
      console.error('Failed to load employment type options:', error);
      message.error('Failed to load employment type options');
      if (onDropdownLoad) onDropdownLoad();
    } finally {
      setLoading(false);
    }
  }, [onDropdownLoad]);

  useEffect(() => {
    loadEmploymentOptions();
  }, [loadEmploymentOptions]);

  const handleEmploymentChange = (employmentCode: string) => {
    onChange(employmentCode);
  };

  // DEBUG LOG for dropdown value debugging
  console.log('EmploymentTypeDropdown value:', value, 'options:', employmentOptions);

  return (
    <SimpleDropdown
      options={employmentOptions}
      value={value}
      onChange={handleEmploymentChange}
      placeholder={loading ? "Loading..." : placeholder}
      disabled={disabled || loading}
    />
  );
};

export default EmploymentTypeDropdown; 